import api from './axiosService';

export const authApi = {
    login(credentials) {
        return api.post('/login', credentials);
    },

    register(data) {
        return api.post('/register', data);
    },

    logout() {
        return api.post('/logout');
    },

    me() {
        return api.get('/me', { skipAuthRedirect: true });
    },

    refresh() {
        return api.post('/refresh', null, { skipAuthRedirect: true });
    },

    changePassword(data) {
        return api.post('/change-password', data, {
            headers: {
                'X-Password-Change': 'true'
            }
        });
    },

    forgotPassword(data) {
        return api.post('/forgot-password', data);
    },

    verifyOtp(data) {
        return api.post('/verify-otp', data);
    },

    resetPassword(data) {
        return api.post('/reset-password', data);
    },
};